import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import useIsMobile from '../../Hooks/useIsMobile';

const YotpoUgc = ({ productId }: { productId: string }) => {
  const { galleryId, galleryIdMobile } = useTypedSelector((state) => state.yotpo);
  const isMobile = useIsMobile();

  return (
    <div
      className="yotpo yotpo-pictures-widget"
      data-gallery-id={isMobile ? galleryIdMobile : galleryId}
      data-product-id={productId}
    ></div>
  );
};

export default YotpoUgc;